// extracted by mini-css-extract-plugin
module.exports = {"inner":"TextLoading_inner__Lo0-K","shine":"TextLoading_shine__3MG0J","inner_inline":"TextLoading_inner_inline__2Hknu"};